import { useLocation } from 'react-router-dom';
import { FrontErrorView } from '../components/FrontErrorView';

export function FrontErrorPage() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const value = location.pathname.split('/')[2] || query.get('status') || query.get('code') || '500';
  const number = Number(value);
  const status = Number.isInteger(number) && number >= 400 && number <= 599 ? number : 500;
  return <FrontErrorView status={status} onRetry={() => window.location.reload()} onBack={() => window.history.length > 1 ? window.history.back() : window.location.assign('/front-v2/home')} />;
}
